import { Component, OnInit, ViewChild } from '@angular/core';
import { AlertDialog, DialogType, AlertCommand, MessageSeverity, AlertService } from './shared/alert.service';

import { AppTranslationService } from './shared/app-translation.service';
import { AuthService } from './shared/auth.service';
import {
  Event,
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router
} from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  role: string;
  stickyToasties: number[] = [];

  //@ViewChild('videoPlayer') videoplayer: ElementRef;
  
  gT = (key: string | Array<string>, interpolateParams?: Object) => this.translationService.getTranslation(key, interpolateParams);
  constructor(
    private translationService: AppTranslationService,
    private _authService: AuthService,
    public router: Router,
    ) {
      
     
  }
  headerFooter:any;
  ngOnInit() {
    this.router.events
    .subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.headerFooter = (event.url !== '/VideoPlayer')
      }
    });
    // if (this._authService.userRole && this._authService.userRole == 'admin') {
    //   this.role = this._authService.userRole;
    // } else {
    //   this.role = '';
    // }
  }
  oncclick(){
    this.router.navigate(['/accounts']);
  }
}
